import type { SxProps, Theme } from '../../../themes/themes';

export const getStyles = ({ theme }: { theme: Theme }): { [key: string]: SxProps } => {
  return {
    container: {
      transparent: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.palette.grey['A100'],
        padding: `${theme.spacing(5)} 0`,
        margin: 0,
        [theme.breakpoints.up('md')]: {
          background: 'transparent',
          padding: `${theme.spacing(9)} 0`,
        },
      },
      white: {
        display: 'flex',
        flexDirection: 'column',
        background: theme.palette.grey['A100'],
        padding: `${theme.spacing(5)} 0`,
        margin: 0,
        [theme.breakpoints.up('md')]: {
          background: theme.palette.common.white,
          padding: `${theme.spacing(9)} 0`,
          paddingTop: 0,
        },
      },
    },
    title: {
      transparent: {
        display: 'inline-flex',
        justifyContent: 'center',
        color: theme.palette.primary.contrastText,
        marginBottom: theme.spacing(5),
        [theme.breakpoints.up('md')]: {
          marginBottom: theme.spacing(8),
        },
      },
      white: {
        display: 'inline-flex',
        justifyContent: 'center',
        color: theme.palette.primary.contrastText,
        marginBottom: theme.spacing(5),
        [theme.breakpoints.up('md')]: {
          color: theme.palette.text.primary,
          marginBottom: theme.spacing(8),
        },
      },
    },
    divider: {
      transparent: {
        display: 'none',
        margin: `0 ${theme.spacing(8)}`,
        marginBottom: theme.spacing(5),
        [theme.breakpoints.up('md')]: {
          display: 'block',
          borderColor: 'rgba(255,255,255,0.5)',
          margin: `0 ${theme.spacing(12)}`,
          marginBottom: theme.spacing(9),
        },
      },
      white: {
        display: 'none',
        marginBottom: theme.spacing(5),
        [theme.breakpoints.up('md')]: {
          display: 'block',
          borderColor: theme.palette.grey['light'],
          marginBottom: theme.spacing(9),
        },
      },
    },
    navigation: {
      transparent: {
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'stretch',
        color: theme.palette.primary.contrastText,
      },
      white: {
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'stretch',
        color: theme.palette.primary.contrastText,
        [theme.breakpoints.up('md')]: {
          color: theme.palette.text.primary,
        },
      },
    },
    navigationBar: {
      backgroundColor: 'transparent',
      width: '100%',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: 1,
      visibility: 'hidden',
    },
    navigationBarShow: {
      backgroundColor: theme.palette.grey['A100'],
      visibility: 'visible',
    },
    navigationStickyHeaderBar: {
      backgroundColor: 'transparent',
      width: '100%',
      position: 'fixed',
      left: 0,
      top: 71,
      visibility: 'hidden',
      zIndex: 1,
      opacity: 0,
      transition: 'visibility 0.1s ease-out, opacity 0.1s ease-in-out, background-color 0.1s ease-out',
      [theme.breakpoints.up('lg')]: {
        top: 103,
      },
    },
    navigationStickyHeaderBarShow: {
      backgroundColor: theme.palette.grey['A100'],
      opacity: 1,
      transition: 'opacity 0.3s ease-in-out',
      visibility: 'visible',
    },
    navigationBarInner: {
      color: theme.palette.primary.contrastText,
      padding: `${theme.spacing(4)} 0`,
      backgroundColor: theme.palette.grey['A100'],
      display: 'flex',
      justifyContent: 'center',
    },
  };
};
